import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { get } from 'lodash'
import { apiConfiguration } from 'helpers/decorators/api'
import { FormData } from 'components/misc'

@apiConfiguration()
class ConfigurationText extends PureComponent {
  static propTypes = {
    label: PropTypes.string,
    intlKey: PropTypes.string,
    configKey: PropTypes.string.isRequired,
    onGetConfigurationValue: PropTypes.func,
    organizationId: PropTypes.number,
    isPublic: PropTypes.bool
  }

  state = {
    text: ''
  }

  componentDidMount() {
    this.handleRequestDownload()
  }

  handleRequestDownload = () => {
    // eslint-disable-next-line
    let { organizationId, configKey, isPublic } = this.props

    if (isPublic) {
      organizationId = organizationId || 1
    }

    this.props
      .onGetConfigurationValue(configKey, organizationId, isPublic)
      .then(({ body } = {}) => {
        this.setState({
          text: get(body, 'translatedText')
        })
      })
  }

  render() {
    const { label, intlKey } = this.props

    return (
      <FormData label={label} intlKey={intlKey}>
        <span dangerouslySetInnerHTML={{ __html: this.state.text }} />
      </FormData>
    )
  }
}

export default ConfigurationText
